// extracted by mini-css-extract-plugin
module.exports = {"iframeScrollWrapper":"iframeScrollWrapper-nHGSK","iframeContent":"iframeContent-lQkoW","splashScreen":"splashScreen-Ptp0n","loadingWrapper":"loadingWrapper-7pTEe"};